import { ShieldAlert } from "@/components/icons"
import { Checkbox } from "@/components/ui/checkbox"

type EscalationToggleProps = {
  requested: boolean
  onToggle: (requested: boolean) => void
  description: string
  checkboxLabel: string
}

/**
 * Shown only when a report is eligible for escalation (see `shouldEscalate`).
 * Lets the user decide whether it actually pages support, rather than that
 * being an automatic consequence of their answers — same opt-out shape as
 * `ScreenshotAttachment`, state lifted to the dialog so it survives step
 * navigation.
 */
export function EscalationToggle({
  requested,
  onToggle,
  description,
  checkboxLabel,
}: EscalationToggleProps) {
  const checkboxId = "feedback-escalate-requested"

  return (
    <div className="border-primary/30 bg-primary/5 space-y-2 rounded-md border p-3 text-xs">
      <div className="flex items-start gap-3">
        <ShieldAlert className="text-primary mt-0.5 size-4 shrink-0" />
        <p className="text-foreground">{description}</p>
      </div>
      <div className="flex items-center gap-2 pl-7">
        <Checkbox
          checked={requested}
          id={checkboxId}
          onCheckedChange={(checked) => onToggle(checked === true)}
        />
        <label
          className="text-muted-foreground hover:text-foreground cursor-pointer transition-colors"
          htmlFor={checkboxId}
        >
          {checkboxLabel}
        </label>
      </div>
    </div>
  )
}
